import React, { useEffect, useState } from "react";
import "../css/bar-locator.css";

const locations = [
  {
    id: "hyderabad",
    name: "HYDERABAD",
    details: [
      "Rajiv Gandhi International Airport, Hyderabad",
      "Departure - Hyderabad Duty Free",
      "Arrival - Hyderabad Duty Free",
    ],
  },
  {
    id: "delhi",
    name: "DELHI",
    details: [
      "Indira Gandhi International Airport, Delhi",
      "Departure - Delhi Duty Free",
      "Arrival - Delhi Duty Free",
    ],
  },
  {
    id: "mumbai",
    name: "MUMBAI",
    details: [
      "Chhatrapati Shivaji Maharaj International Airport, Mumbai",
      "Departure - Mumbai Duty Free",
      "Arrival - Mumbai Duty Free",
    ],
  },
  {
    id: "bengaluru",
    name: "BENGALURU",
    details: [
      "KEMPEGOWDA INTERNATIONAL AIRPORT, BENGALURU",
      "DEPARTURE - BENGALURU DUTY FREE",
    ],
  },
  {
    id: "gurugram",
    name: "Gurugram",
    details: [
      {
        href: "https://maps.google.com/?q=28.486639,77.060234",
        label:
          "Times for wine, Sector 17/18, Dividing road, Gurugram, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.505669,77.069847",
        label:
          "Scotchtap liquor shop, Jawala Mill chowk, Sector 22, Gurugram, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.432798,77.052124",
        label:
          "Firewater store, Dockyard BYOB, Sector 47, Gurugram, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.518518,77.024475",
        label:
          "Times for wine, One of -BYOB, Sector 110A, Gurugram, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.502817,77.065086",
        label:
          "Scotchtap liquor shop, Sector 22 Huda Market, Gurugram, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.432877,77.042442",
        label: "Firewater store, Sector 38 Huda Market, Gurugram, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.514011,77.018173",
        label:
          "Times for wine, Dwarka Expressway, New Palam Vihar, Sector 110, Gurugram, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.535034,77.018059",
        label:
          "Times for wine, Bajghera road, Gurugram (Delhi MCD Border), Haryana",
      },
      {
        href: "https://maps.app.goo.gl/cGu9rfNVYGVTeVbn8?g_st=aw",
        label:
          "Firewater store, Where Else-BYOB, Ghata, Sector 55-56, Gurugram, Haryana",
      },
    ],
  },
  {
    id: "faridabad",
    name: "Faridabad",
    details: [
      {
        href: "https://maps.google.com/?q=28.433502,77.136124",
        label:
          "Firewater store, Vallie view estate, Gwal Pahadi, Gurgaon-Faridabad Road, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.430279,77.348274",
        label:
          "Firewater store, Gopichand chowk, Near by Munshi firm, Faridabad, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.492628,77.292534",
        label:
          "Firewater store, Charmswood Village, Near by Surajkund border, Faridabad, Haryana",
      },
      {
        href: "https://maps.google.com/?q=28.412397,77.318016",
        label:
          "Firewater store, Sector 16, Near by Om Sweets, Faridabad, Haryana",
      },
    ],
  },
];

const AccordionIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 33 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M2.35462 2L15.395 20.8142C15.7927 21.388 16.641 21.388 17.0387 20.8142L30.0791 2"
      stroke="#7E573E"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BarLocator = () => {
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    $(".home-secion4").addClass("activetitle");

    const sections = $("section");
    const activateVisibleSections = function () {
      const currentPosition = $(this).scrollTop();

      sections.each(function () {
        const top = $(this).offset().top - 200;
        const bottom = top + $(this).outerHeight();

        if (currentPosition >= top && currentPosition <= bottom) {
          $(this).addClass("activetitle");
        }
      });
    };

    $(window).on("scroll", activateVisibleSections);
    return () => $(window).off("scroll", activateVisibleSections);
  }, []);

  const handleNavLinkClick = (sectionId) => {
    setActiveSection((currentSection) =>
      currentSection === sectionId ? null : sectionId
    );
  };

  return (
    <div className="barlocator_page">
      <section className="home-secion4 bar-section">
        <div className="vertical_moutain_1">
          <img src="images/newleftfind.png" alt="side mountain" />
        </div>
        <div className="vertical_moutain_2">
          <img src="images/right-find.png" alt="side mountain right" />
        </div>
        <div className="duble_moutain">
          <div className="vertical_moutain_1">
            <img src="images/newleftfind.png" alt="side mountain" />
          </div>
          <div className="vertical_moutain_2">
            <img src="images/right-find.png" alt="side mountain right" />
          </div>
        </div>

        <div className="container small-container text-center">
          <div className="rum_glass">
            <img src="images/rumglass.png" alt="side mountain right" />
          </div>
          <h1 className="h2 site-color text-uppercase animatetext">FIND US</h1>
          <div className="gray-text">
            <p>CHOOSE YOUR LOCATION</p>
            <div className="v-line small-line">
              <svg
                className="sc-16mwcw0-0 iZNjkc"
                width="2"
                height="283"
                viewBox="0 0 2 283"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M1 0L0.999988 283"
                  stroke="#7E573E"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>

          <div className="container barcon">
            <nav className="bar_detail" aria-label="Store locations">
              <ul className="barpanne">
                {locations.map((location) => {
                  const isActive = activeSection === location.id;
                  const buttonId = `location-button-${location.id}`;
                  const panelId = `location-panel-${location.id}`;

                  return (
                    <li className="location-accordion-item" key={location.id}>
                      <button
                        id={buttonId}
                        type="button"
                        className={isActive ? "active" : ""}
                        aria-expanded={isActive}
                        aria-controls={panelId}
                        onClick={() => handleNavLinkClick(location.id)}
                      >
                        <div className="barmenu">
                          <AccordionIcon />
                          <p>{location.name}</p>
                        </div>
                      </button>

                      <div
                        id={panelId}
                        className={`location-accordion-panel${
                          isActive ? " active" : ""
                        }`}
                        role="region"
                        aria-labelledby={buttonId}
                        aria-hidden={!isActive}
                      >
                        <div className="location-accordion-panel-inner bardetails">
                          {location.details.map((detail, index) =>
                            typeof detail === "string" ? (
                              <p key={`${location.id}-${index}`}>{detail}</p>
                            ) : (
                              <a
                                key={detail.href}
                                href={detail.href}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {detail.label}
                              </a>
                            )
                          )}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </nav>
          </div>
        </div>

        <div className="rum_glass left-side">
          <img src="images/rumglassleft.png" alt="side rum left" />
        </div>
      </section>
    </div>
  );
};

export default BarLocator;
